import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch" }
const _hoisted_2 = { class: "switch__caption" }
const _hoisted_3 = { class: "switch__input" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "switch-1",
  class: "switch__input__label"
}, "Switch", -1)



export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchInput',
  props: /*#__PURE__*/_mergeModels({
    caption: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel<boolean>(__props, "modelValue")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t(_ctx.caption)) + "?", 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        id: "switch-1",
        type: "checkbox",
        class: "switch__input__checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
      }, null, 512), [
        [_vModelCheckbox, model.value]
      ]),
      _hoisted_4
    ])
  ]))
}
}

})